module.exports = __webpack_public_path__ + "static/media/sales-row-bg.a3c1096a.jpg";